import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Table from '../components/ReGenerateTable';
import axios from "../../src/utils/axiosConfig";
import GenerateResultModal from "../components/Test/GenerateResultModal"
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    btnPadding: {
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
        fontSize: "0.775rem"
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar
    },
    content: {
        flexGrow: 80,
        padding: theme.spacing(3),
    }
}));
export default function FullWidthGrid(props) {
    const classes = useStyles();
    const {adminData,tableData} = props;
    const [open, setOpen] = React.useState(false);
    React.useEffect(()=>{

      },[])

    const reGenerateResult = () => {
        setOpen(true)
        axios.get('/test/generate-result', {
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        }).then(response => {
            let res = response;
        }).catch(error => {
            console.log("Error reGenerateResult", error);
        });
    }

    return (
        <>
            <main className={classes.content}>
                <div className={classes.toolbar} />

                <div className='row' style={{ display: 'flex' }}>
                    <Grid item xs={6}>
                        <b><h3 style={{ color: "#7030a0", fontSize: "20px", marginBottom: "20px" }}>Pending Results</h3></b>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: "right", alignSelf: "center" }}>
                        <Button className='generate-btn' variant="outlined" name='reGenerateResult' id='regenerateResult' color="primary" disabled = {tableData.length <= 0} onClick={() => reGenerateResult()}>ReGenerate</Button>
                    </Grid></div>
                 <GenerateResultModal open = {open} setOpen={setOpen} />
                <Grid container spacing={3}>
                    <Grid style={{ paddingBottom: "0px" }} item xs={12}>
                    </Grid>
                    <Grid item xs={12}>
                        <Table tableData={tableData} />
                    </Grid>
                </Grid>
            </main>
        </>
    );
}